var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_vm._v(" // 点击退出按钮时执行loginout "),_c('el-button',{attrs:{"type":"info"},on:{"click":_vm.logout}},[_vm._v("退出")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }